import React, { useMemo, useCallback, useState, useEffect } from 'react';

import {
  TextField,
  FormControl,
  Select,
  MenuItem,
  IconButton,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { concat, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function Search({ options, onSearch }) {
  const [column, setColumn] = useState('');
  const [text, setText] = useState('');

  const renderOptions = useMemo(
    () =>
      options.map((option, key) => (
        <MenuItem key={`options-${key}`} value={option.id}>
          {option.label}
        </MenuItem>
      )),
    [options]
  );

  const handleChangeSelect = useCallback((value) => {
    setColumn(value);
  }, []);

  const handleChangeText = useCallback((value) => {
    setText(value);
  }, []);

  const handleSubmit = useCallback(() => {
    onSearch({ column, text });
  }, [column, text, onSearch]);

  useEffect(() => {
    if (!isEmpty(options)) setColumn(concat([], options).shift().id);
  }, [options]);

  return (
    <S.Wrapper>
      <TextField
        size="small"
        variant="outlined"
        label="Pesquisa"
        value={text}
        onChange={({ target }) => handleChangeText(target.value)}
      />

      <FormControl size="small" variant="outlined">
        <Select
          value={column}
          onChange={({ target }) => handleChangeSelect(target.value)}
        >
          {renderOptions}
        </Select>
      </FormControl>

      <IconButton color="primary" onClick={handleSubmit}>
        <SearchIcon />
      </IconButton>
    </S.Wrapper>
  );
}

Search.propTypes = {
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  onSearch: PropTypes.func.isRequired,
};
